import {noop} from "@hosttools/core/constant";
import {createContext} from "react";

import type {PressableRef} from "../ui/pressable";

export type TabGroupContextType<T = any> = {
    size: "sm" | "md";
    tab: T | undefined;
    onTabChange?: (id: T) => void;
    registerTabRef: (id: T, ref: PressableRef) => void;
};

export const TabGroupContext = createContext<TabGroupContextType>({
    size: "sm",
    tab: undefined,
    registerTabRef: noop
});
